import type { ReactNode } from 'react'

import { useStyles } from './styles'

type Props = {
  children: ReactNode
}

/**
 * A non-scrolling-page code block: horizontal overflow scrolls inside the box rather than pushing
 * the card wider.
 *
 * Extracted because two cards had the same style block copied between them — the credentials Quick
 * Start sample and the webhook signature sample — and a copied style block is a missing component.
 */
export const CodeSnippet = ({ children }: Props) => {
  const { styles } = useStyles()

  return <pre className={styles.code}>{children}</pre>
}

/** Companion class for the bulleted notes these cards render under the snippet. */
export const useSnippetTipsStyles = () => {
  const { styles } = useStyles()

  return styles.tips
}
